import * as React from 'react';
import { ChangeEvent } from 'react';
import { FilterOptions } from '../../Filter/FilterOptions';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { Trans } from '../Trans';

interface BranchSelectBoxProps {
    models: JobCenterModelInterface[],
    valueId: string | number | undefined
    placeholder?: string
    onChange: (selection: string | undefined, event: ChangeEvent<HTMLSelectElement>) => void
}

interface BranchSelectBoxState {
    value: string | undefined
}

export class BranchSelectBox extends React.Component<BranchSelectBoxProps, BranchSelectBoxState> {
    constructor(props: BranchSelectBoxProps, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            value: undefined
        };
    }

    public render() {
        const value = this.state.value;
        const options = this.getOptions();
        const className = 'job-center-filter-field job-center-filter-field-branch';
        const props = this.props;
        const selectedValueIdFromProperties = props.valueId ? '' + props.valueId : undefined;

        return <div className={className}>
            <label>
                {this.renderLabel()}
                <select value={value || selectedValueIdFromProperties} onChange={this.handleChange}>
                    <option value=''>{props.placeholder || ''}</option>
                    {options.map(i => <option key={i} value={i}>{i}</option>)}
                </select>
            </label>
        </div>;
    }

    private getOptions(): string[] {
        return FilterOptions.collectOptions(this.props.models, 'applicationContact.city');
    }

    private handleChange(event: ChangeEvent<HTMLSelectElement>) {
        const value = event.target.value;
        if (value !== '') {
            this.props.onChange(value, event);
        } else {
            this.props.onChange(undefined, event);
        }
    }

    protected renderLabel() {
        return <>
            <span className="sr-only"><Trans>Filiale</Trans></span>
            <i className="fas fa-chart-pie"/>
            {this.props.children}
        </>;
    }
}
